import { NotificationManagementService } from './service/notification-management.service';
import { ProfileService } from './../../../../../services/profile/profile.service';
import { NotificationService } from './../../../../../services/notification/notification.service';
import { LabelsService } from './../../../../../util/services/labels/labels.service';
import { Component, OnInit } from '@angular/core';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { notificationInterface } from 'src/app/util/interfaces/notification';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { customerInterface } from 'src/app/util/interfaces/customer';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
	selector: 'register-notification-management',
	templateUrl: './notification-management.component.html',
	styleUrl: './notification-management.component.scss',
})
export class NotificationManagementComponent implements OnInit {
	labels: any = {
		lbl_geral_cliente: '',
		lbl_geral_tipo_notificacao: '',
		lbl_geral_titulo: '',
		lbl_geral_detalhamento: '',
		lbl_geral_data_limite2: '',
		lbl_geral_pesquisar: '',
		lbl_geral_gerenciamento_notificacao: '',
		lbl_geral_novo: '',
		lbl_geral_selecione: '',
		lbl_salvo_com_sucesso: '',
		lbl_preencha_todos_asteriscos: '',
		lbl_geral_anuncio: '',
		lbl_geral_importante: '',
		lbl_geral_novidade: '',
		lbl_geral_urgent: '',
		lbl_geral_preencha_data_corretamente: '',
		lbl_geral_formato_data_limite_aaaaMMdd_HHmm: '',
		lbl_data_invalida: '',
	};

	icons = {
		faQuestionCircle: faQuestionCircle,
	};

	constructor(
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private NotificationManagementService: NotificationManagementService,
		public ProfileService: ProfileService
	) {}

	isLabelsLoading = true;
	isNotificationsLoading = true;
	isCustomersLoading = true;
	isUpdatingNotification = false;

	selectedNotification: notificationInterface = undefined;
	selectedIndex: number;

	notifications: notificationInterface[] = [];
	customers: customerInterface[] = [];

	searchHeader: mspTableHeaderI[] = [
		{ name: 'summary', value: 'lbl_geral_titulo', colType: 'text' },
		{ name: 'type', value: 'lbl_geral_tipo_notificacao', colType: 'text' },
		{ name: 'limit_date', value: 'lbl_geral_data_limite2', colType: 'text' },
		{ name: 'description', value: 'lbl_geral_detalhamento', colType: 'text' },
		{ name: 'customer', value: 'lbl_geral_cliente', colType: 'text' },
	];

	filter: any = {
		type: '',
		summary: '',
	};

	editorConfig: AngularEditorConfig = {
		editable: true,
		translate: 'no',
		outline: false,
		uploadUrl: 'v1/image',
		minHeight: '5rem',
		height: '15rem',
		toolbarHiddenButtons: [
			['undo', 'redo', 'heading', 'fontName', 'defaultFontName', 'uploadUrl'],
			['customClasses', 'insertVideo', 'insertImage', 'insertHorizontalRule', 'removeFormat', 'subscript', 'superscript'],
		],
	};

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe({
			next: (labels) => {
				this.labels = labels;
			},
			complete: () => {
				this.isLabelsLoading = false;
			},
		});

		this.ProfileService.getAvailableCustomers().subscribe({
			next: (availableCustomers) => {
				this.customers = availableCustomers;
			},
			complete: () => {
				this.isCustomersLoading = false;
			},
		});

		this.getNotifications('', '');
	}

	addNewNotification(): void {
		this.selectedNotification = {
			id: '-1',
			customer: '',
			type: 'Announcement',
			summary: 'Nova notificação',
			description: '',
			limit_date: '',
		};
	}

	searchNotifications(): void {
		if (this.isNotificationsLoading) return;
		this.getNotifications(this.filter.summary, this.filter.type);
	}

	getNotifications(summary: string, type: string): void {
		this.isNotificationsLoading = true;

		this.NotificationManagementService.getNotifications(summary, type).subscribe({
			next: (notification) => {
				this.notifications = JSON.parse(JSON.stringify(notification));
			},
			complete: () => {
				this.isNotificationsLoading = false;
			},
		});
	}

	createNotification(): void {
		if (this.isUpdatingNotification) return;

		const dateReg = /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\s([01]\d|2[0-3]):([0-5]\d)$/;
		if (!dateReg.test(this.selectedNotification.limit_date)) {
			return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_data_corretamente);
		}

		const limitDate = new Date(this.selectedNotification.limit_date);
		const now = new Date();

		if (limitDate < now) {
			return this.NotificationService.setNotificationMessage(this.labels.lbl_data_invalida);
		}

		if (!this.validateFullFilledForm())
			return this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);

		this.isUpdatingNotification = true;
		this.NotificationManagementService.createNotification(this.selectedNotification).subscribe({
			next: (notificationRes) => {
				this.selectedNotification.id = notificationRes[0];
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
			},
			complete: () => {
				this.isUpdatingNotification = false;
			},
		});
	}

	updateNotification(): void {
		if (this.isUpdatingNotification) return;

		const dateReg = /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\s([01]\d|2[0-3]):([0-5]\d)$/;
		if (!dateReg.test(this.selectedNotification.limit_date)) {
			return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_data_corretamente);
		}

		const limitDate = new Date(this.selectedNotification.limit_date);
		const now = new Date();

		if (limitDate < now) {
			return this.NotificationService.setNotificationMessage(this.labels.lbl_data_invalida);
		}

		if (!this.validateFullFilledForm())
			return this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);

		this.isUpdatingNotification = true;
		this.NotificationManagementService.updateNotification(this.selectedNotification).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
			},
			complete: () => {
				this.isUpdatingNotification = false;
			},
		});
	}

	deleteNotification(): void {
		this.NotificationManagementService.deleteNotification(this.selectedNotification.id).subscribe({
			complete: () => {
				this.notifications.splice(this.selectedIndex, 1);
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
				this.selectedNotification = undefined;
				this.selectedIndex = undefined;
			},
		});
	}

	selectNotification(notification: notificationInterface): void {
		this.selectedNotification = notification[0];
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}

	validateFullFilledForm(): boolean {
		let fullFilledForm = true;

		for (const key of Object.keys(this.selectedNotification)) {
			if (this.selectedNotification[key] == '' && key != 'customer') fullFilledForm = false;
		}

		return fullFilledForm;
	}
}
